import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {ViewSelectors} from "../../logics/view";

@Component({
  selector: 'cs-page-title',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div 
      class="cs-page-title" 
      [ngClass]="{'cs-report-page-title': inputs.isReport}">
      <a 
          *ngIf="!inputs.isReport"
	  	class="cs-btn ion-loop sendlog-btn"
		[ngClass]="{
			'disabled': !inputs.refreshEnabled || isAudioExtPlaying
		}"
		(click)="log(inputs.refreshEnabled && !isAudioExtPlaying, inputs.currentQuestion.id)">
      </a>
      <h1>{{ ((inputs.titleOverride && inputs.titleOverride[inputs.currentQuestion.id]) ? inputs.titleOverridePrefix + inputs.titleOverride[inputs.currentQuestion.id].title : inputs.title) }}</h1>
      <cs-player 
        *ngIf="!inputs.isReport && inputs.currentQuestion.audioText"
        [inputs]="{
          currentId: inputs.currentPlayerId,
          src: inputs.currentQuestion.audioText.audioURI
        }"
        (play)="play.emit($event)"
        (stop)="stop.emit()">
      </cs-player>
      <!--
      <a 
        class="ion-close-round" 
        *ngIf="inputs.isReport">
      </a>
      -->
    </div>
  `
})

export class CsPageTitleComponent {
  @Input() inputs: any = {};
  @Output() play = new EventEmitter<Object>();
  @Output() stop = new EventEmitter<Object>();
  @Output() sendLog = new EventEmitter<Object>();

	log(can, questionId){
		if(can) this.sendLog.emit(questionId);
	}

  private isAudioExtPlaying: boolean = false;

  isAudioExtPlaying$: Observable<any>;
  destroyed$: Subject<any> = new Subject<any>();

  constructor(
    private viewSelectors: ViewSelectors
  ) {
    this.isAudioExtPlaying$ = this.viewSelectors.isAudioExtPlaying();
  }

  ngOnInit () {
    this.isAudioExtPlaying$
      .takeUntil(this.destroyed$)
      .subscribe(isAudioExtPlaying => this.isAudioExtPlaying = isAudioExtPlaying);
  }

  ngOnDestroy () {
    this.destroyed$.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cs-page-title/cs-page-title.component.ts